if (!window.Eurus.loadedScript.has('cosmoprof-event.js')) {
  window.Eurus.loadedScript.add('cosmoprof-event.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('cosmoprofEvent', (config) => ({
        show: false,
        showWidget: config.enableWidget !== false,
        widgetExpanded: true,
        registrationUrl: null,
        init() {
          this.fetchRegistrationUrl(config);

          if (!config.enableModal) return;

          if (Shopify.designMode) {
            this.show = true;
            return;
          }

          const storageKey = 'cosmoprof-event-seen-' + config.sectionId;
          if (localStorage.getItem(storageKey) === 'true') return;

          if (!config.showOnMobile && window.innerWidth < 768) return;

          setTimeout(() => {
            this.open(storageKey);
          }, config.delay * 1000);
        },
        fetchRegistrationUrl(config) {
          const callbackName = '__cosmoprofReg_' + Date.now();
          window[callbackName] = (data) => {
            delete window[callbackName];
            if (script.parentNode) script.parentNode.removeChild(script);

            if (data && data.widgetIsValid === 'Y') {
              this.registrationUrl =
                'https://www.compusystems.com/servlet/Wt?x=' +
                data.widgetEventUID + '.' + data.widgetOrgId + '.' + data.widgetIdent + '|' + data.widgetRegURL;
            }
          };

          const script = document.createElement('script');
          script.src =
            'https://www.compusystems.com/jsp/Widget/widget.jsp?auth=' +
            encodeURIComponent(config.widgetAuthId) +
            '&org=' + encodeURIComponent(config.widgetOrgId) +
            '&evt=' + encodeURIComponent(config.widgetEvtId) +
            '&size=&jsonp=' + callbackName;
          script.onerror = () => {
            delete window[callbackName];
          };
          document.head.appendChild(script);
        },
        open(storageKey) {
          this.show = true;
          requestAnimationFrame(() => {
            document.body.classList.add('overflow-hidden');
          });
          this.setOverlay();

          if (!Shopify.designMode && storageKey) {
            localStorage.setItem(storageKey, 'true');
          }
        },
        close() {
          this.show = false;
          requestAnimationFrame(() => {
            document.body.classList.remove('overflow-hidden');
          });
          this.removeOverlay();
        },
        openRegistration() {
          if (this.registrationUrl) {
            window.open(this.registrationUrl, '_blank', 'noopener,noreferrer');
            this.close();
            return;
          }

          const widgetBtn = document.querySelector(
            '#widget input[type="button"], #widget .CSIWidgetbtnPrimary, #widget .fpbtn'
          );
          if (widgetBtn) {
            widgetBtn.click();
            this.close();
          }
        },
        setOverlay() {
          const popupsDiv = document.getElementById('eurus-popup');
          if (!popupsDiv || popupsDiv.classList.contains('bg-[#acacac]')) return;
          popupsDiv.className += ' bg-[#acacac] bg-opacity-30';
        },
        removeOverlay() {
          const popupsDiv = document.getElementById('eurus-popup');
          if (popupsDiv && popupsDiv.classList.contains('bg-[#acacac]')) {
            popupsDiv.classList.remove('bg-[#acacac]', 'bg-opacity-30');
          }
        }
      }));
    });
  });
}
